export default function isNumberWithExponentialNotation(number) {
  return (
    Number(number)
      .toString()
      .toLowerCase()
      .indexOf("e") !== -1
  );
}
